import Vue from 'vue'

let status = {
  labels(){
    return [
      "unconfirmed",
      "constructing",
      "proof_inhouse",
      "proof_client",
      "approved",
      "delivered",
      "done",
    ];
  },
  color(status){
    let bg = {
      'unconfirmed' : 'danger',
      'comment' : 'warning',
      'created' : 'primary',
      'constructing' : 'gray',
      'proof_inhouse' : 'info',
      'proof_client' : 'purple',
      'forced' : 'warning',
      'approved' : 'warning',
      'delivered' : 'secondary',
      'done' : 'success'
    }

    return bg[status];
  },
  icon(status){
    let icons = {
      "unconfirmed": ['fas','stopwatch'],
      "constructing": ['fas','exclamation'],
      "proof_inhouse": ['fal','shield'],
      "proof_client": ['fas','shield'],
      "approved": ['fas','shield-check'],
      "delivered": ['fas','play-circle'],
      "done": ['fas','badge-check'],
    }

    status = status ? status : 'constructing';
    
    return icons[status];
  }
}

Vue.prototype.status = status;


// WEBPACK FOOTER //
// ./resources/assets/js/plugins/status.js